import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { API_SERVICE_BACKEND } from "src/config";

const ResetPasswordModal = ({ setOpen, open }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setOpen({ open: false, data: null });
  };

  const handleSendEmail = async () => {
    try {
      setIsLoading(true);
      const { email } = open.data;

      await axios.post(`${API_SERVICE_BACKEND}/forgot-password`, { email });

      toast.success("Password reset email sent successfully");
      handleClose();
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open.open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Reset Password</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        <Typography>
          Are you sure you want to send a password reset email?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" variant="contained">
          Cancel
        </Button>
        <Button
          onClick={() => handleSendEmail()}
          color="primary"
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress color="inherit" size={25} />
          ) : (
            "Send Email"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetPasswordModal;
